export const responsive = {
  // MIN_WIDTH: 1024,
  // MIN_HEIGHT: 768,
  MIN_WIDTH: 1280,
  MIN_HEIGHT: 960,
  PIVOT_WIDTH: 1336,
}
